// Auth for the Railway pipeline server (VITE_PIPELINE_URL).
//
// The credential is the signed-in admin's own Supabase access token. The server
// verifies it against Supabase and requires app_metadata.is_admin, so:
//   - nothing secret ships in this bundle (anyone can read the built JS), and
//   - every pipeline run is attributable to a named admin, not to "whoever
//     holds the shared token".
//
// The server still accepts its API_SECRET for machine callers (cron, the
// fastmoss pull scripts). That secret must never be given to a browser client.

import { supabase } from '@/integrations/supabase/client';

export const PIPELINE_URL = import.meta.env.VITE_PIPELINE_URL as string | undefined;

/**
 * fetch() against the pipeline server with the current admin session attached.
 * Throws before hitting the network if the session is gone, so callers surface
 * "sign in again" rather than a bare 401.
 */
export async function pipelineFetch(path: string, init: RequestInit = {}): Promise<Response> {
  if (!PIPELINE_URL) throw new Error('VITE_PIPELINE_URL is not configured in .env');

  const { data: { session } } = await supabase.auth.getSession();
  const token = session?.access_token;
  if (!token) throw new Error('Your session has expired — sign out and back in, then retry.');

  return fetch(`${PIPELINE_URL}${path}`, {
    ...init,
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`,
      ...init.headers,
    },
  });
}
